import 'xss-filters';
import { skeletonEngine, skeletonPwa } from 'skeletonpwa';
import kfuseRumSDK from 'kf-browser-sdk';
import IdleJs from './packages/addons/idleProvider/idle';
import './packages/addons/otelInstrumentation';

const moduleVersion = require('../package.json').version;

const getSitePrefix = () => {
  let BASE = window.env.SITE_PREFIX
    ? window.env.SITE_PREFIX
    : (window.env.SITE_PREFIX = '/');
  return BASE;
};

const getCdnPath = () => {
  let PATH = window.env.CDN_PATH ? window.env.CDN_PATH : '';
  return PATH;
};

const getCdnPrefix = () => {
  let PREFIX = window.env.CDN_PREFIX ? window.env.CDN_PREFIX : '';
  return PREFIX;
};

const appBase = getSitePrefix();
const cdnPath = getCdnPath();
const cdnPrefix = getCdnPrefix();

let skeletonPath = `${appBase !== '/' ? appBase : ''}/skeleton/assets/`;

if (cdnPath) {
  skeletonPath = cdnPrefix
    ? `${cdnPath}/skeleton/${cdnPrefix}/public/assets/`
    : `${cdnPath}/skeleton/v${moduleVersion}/public/assets/`;
}

__webpack_public_path__ = skeletonPath;

let getCssPackages = () => {
  var req = require.context(
    '../node_modules',
    true,
    /\/datashop-styles\/public\/(?!tests|assets|views)(.*)\.js$/
  );
  req.keys().map(req);
};

import('./packages')
  .then(({ getPackages, getLocalPackages }) =>
    Promise.all([
      // import('../bundle/public/skeletonViews.js'),
      // getNodePackages(),
      getLocalPackages(),
      getPackages(),
      getCssPackages()
      // import('../bundle/public/skeletonSpa.js')
    ])
  )
  .then(resolved => {
    const builduri = base => uri => {
      if (uri) {
        let startToken = uri[0];
        if (uri.length === 1 && uri.indexOf('/') === 0) {
          return base;
        }
        return `${base}${uri}`;
      }
      return base;
    };
    const apiBase = builduri(window.location.origin);

    const routerOpts = {
      resolveRoute(context, params) {
        if (typeof context.route.action === 'function') {
          return context.route.action(context, params);
        }
        return undefined;
      }
    };
    const routeConfig =
      window.env.SITE_PREFIX.length === 1 &&
      window.env.SITE_PREFIX.indexOf('/') === 0
        ? routerOpts
        : Object.assign(routerOpts, {
            baseUrl: window.env.SITE_PREFIX
          });
    const appCfg = {
      api: apiBase(window.env.SITE_PREFIX),
      publicConfig: '/api/get-public-config',
      angularModules: '/_getModules',
      routeConfig,
      prefixSite: window.env.SITE_PREFIX,
      routes: [],
      elements: [
        'ul',
        'li',
        'head',
        'section',
        'base',
        'tr',
        'td',
        'table',
        'tbody',
        'thead',
        'body',
        'script',
        'style',
        'img',
        'form',
        'input',
        'p',
        'label',
        'h3',
        'h5',
        'i',
        'br',
        'b'
      ]
    };

    let loadApp = appLoaded => {
      const datashop = appLoaded();
      const singleSpa = datashop.app.module('singleSpa');
      const $window = datashop.app.module('$window');
      const $document = datashop.app.module('$document');
      const auth = datashop.app.module('auth');
      const idleActivity = datashop.app.module('idleActivity');
      const mixpanelService = datashop.app.module('mixpanelService');
      const fullstoryService = datashop.app.module('fullstoryService');
      const defaultConfig = {
        orgId: 'o-1GTZHF-na1',
        tracking: 'disabled',
        host: 'rs.fullstory.com',
        script: 'edge.fullstory.com/s/fs.js'
      };
      const {
        fullstory,
        kfuseRUM = { config: {}, tracking: 'disabled' }
      } = datashop.app.module('appCfg').config;
      const fullstoryConfig = { ...defaultConfig, ...fullstory };
      const store = datashop.app.module('store');
      let SURVEY_WIDGET_LOADED = false;
      let MIXPANEL_USER_INIT = false;
      if (PRODUCTION) {
        // fullstory initialization
        if (
          fullstoryConfig.tracking == 'enabled' &&
          fullstoryConfig.orgId &&
          fullstoryConfig.orgId.length > 0
        ) {
          fullstoryService.init({
            orgId: fullstoryConfig.orgId,
            host: fullstoryConfig.host,
            script: fullstoryConfig.script
          });
        }
      }

      // Walkme Configuration
      if (
        $window.skeletonPwa.container.appCfg.config.walkmeUrl &&
        $window.skeletonPwa.container.appCfg.config.walkmeUrl.length > 0
      ) {
        var walkme = document.createElement('script');
        walkme.type = 'text/javascript';
        walkme.async = true;
        walkme.src = $window.skeletonPwa.container.appCfg.config.walkmeUrl;
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(walkme, s);
        window._walkmeConfig = { smartLoad: true };
        window.walkme_ready = function() {
          window.isWalkMeLoaded = true;
        };
      }

      // Mixpanel initialization
      mixpanelService
        .init()
        .then(() => {})
        .catch(() => {
          console.log('Mixpanel initialization failed');
        });

      // kfuse RUM initialization
      if (kfuseRUM.tracking === 'enabled') {
        const kfuseConfig = {
          applicationId: '27190558-485a-4fe3-91cc-2ede39e8753f',
          clientToken: 'dummy',
          proxy: 'https://kfuse.innovaccer.com/ddrumproxy',
          service: 'rum-webui-cidev',
          env: 'ci-develop',
          version: '1.0.0',
          sessionSampleRate: 100,
          enableSessionRecording: false,
          enableLogCollection: false,
          ...kfuseRUM.config
        };

        kfuseRumSDK.init({
          config: kfuseConfig
        });
        kfuseRumSDK.startView && kfuseRumSDK.startView({ name: 'skeleton-app' });
      }

      $window.datashop = datashop;
      const modules = datashop.app.module('ngmoduleLoader');
      modules
        .then(d => console.log('loaded', d))
        .catch(e => console.warn('try reload', e));
      singleSpa.start();
      idleActivity.start();
      $window.datashop.app.vent.on('datashop-auth:loginSuccess', () => {
        idleActivity.reset();
      });

      $window.datashop.app.vent.on('datashop-auth:loginRequired', () => {
        $window.datashop.app.vent.emit('datashop-auth:showAuthModal', {
          1: 2
        });
      });
      $window.datashop.app.vent.on(
        'datashop-auth:logoutIdleUser',
        ({ from }) => {
          console.log(`Logout user , because of idle timeout on ${from} app`);
          $window.datashop.app.vent.emit('datashop-auth:showAuthModal', {
            1: 2
          });
          auth.logoutUser({ logoutFromIdleTimeout: true });
        }
      );
      $window.datashop.app.vent.on('AppShell:Loaded', app => {
        const AppShellLoadedEvent = new Event('AppShell:Loaded');
        $document.dispatchEvent(AppShellLoadedEvent);
      });

      $window.datashop.app.vent.emit('AppShell:Loaded', datashop.app);

      $window.datashop.app.vent.on('datashop-auth:setMixpanelUser', user => {
        let BASE = window.env.SITE_PREFIX
          ? window.env.SITE_PREFIX.slice(1)
          : '';
        const distinctUserId = BASE
          ? `${$window.location.hostname}-${BASE}-${user.id}`
          : `${$window.location.hostname}-${user.id}`;
        const customerURL = BASE
          ? `${$window.location.origin}/${BASE}`
          : $window.location.origin;
        mixpanelService.setUserId(distinctUserId);
        mixpanelService.setUserDetails({
          $name: user.name,
          $email: user.email,
          $last_login: user.last_login,
          Organization:
            $window.skeletonPwa.container.appCfg.config.organization_name,
          Role: user.type ? user.type.name : null,
          customerURL
        });
        const userType = user.type
          ? user.type.value || user.type.name || user.type.label || null
          : null;
        fullstoryService.identify(distinctUserId, {
          displayName: user.name,
          email: user.email,
          userType
        });
        // add user info to kfuseRUM
        if (kfuseRUM.tracking === 'enabled') {
          try {
            kfuseRumSDK.setUser({
              id: user.id,
              email: user.email
            });
          } catch (error) {
            console.log('kfuseRUM user info not set', error);
          }
        }
      });

      /** SURVEY START */
      $window.datashop.app.vent.on('datashop-auth:setSurveyUser', user => {
        let BASE = window.env.SITE_PREFIX
          ? window.env.SITE_PREFIX.slice(1)
          : '';
        const distinctUserId = BASE
          ? `${$window.location.hostname}-${BASE}-${user.id}`
          : `${$window.location.hostname}-${user.id}`;
        const customerURL = BASE
          ? `${$window.location.origin}/${BASE}`
          : $window.location.origin;
        const userType = user.type
          ? user.type.value || user.type.name || user.type.label || null
          : null;
        const config = {
          headers: {
            'X-CUSTOMER-ID': customerURL.replace(/[:/.]/g, '_'),
            'X-CUSTOMER-URL': customerURL,
            Authorization: `Auth ${user.token}`,
            'Content-Type': 'application/json',
            'User-Permissions': user.permissions
          },
          identity: {
            user_name: user.name,
            user_id: user.id,
            user_email: user.email,
            user_username: user.username,
            user_firstName: user.firstName,
            user_organization:
              $window.skeletonPwa.container.appCfg.config.organization_name,
            user_type: user.type,
            user_role: user.role,
            customerURL,
            distinctUserId
          }
        };
      });

      /**
       * Eventlistener for survey to send events for logging on mixpanel
       */
      window.addEventListener('survey:mixpanelLogging', ({ detail }) => {
        const { event } = detail;
        mixpanelService.track(`Survey Action - survey ${event}`, {
          category: 'CSAT - Survey'
        });
      });

      /**
       * Initialize survey on page refresh
       */
      const auth$ = store.selectObserver('auth');
      auth$.subscribe(state => {
        if (!SURVEY_WIDGET_LOADED && state.userData && auth.isLoggedIn()) {
          SURVEY_WIDGET_LOADED = true;
          const user = auth.user();
          store.dispatch({ type: 'auth:setSurveyUser', payload: user });
          $window.datashop.app.vent.emit('datashop-auth:setSurveyUser', user);
        }
        if (!MIXPANEL_USER_INIT && state.userData && auth.isLoggedIn()) {
          MIXPANEL_USER_INIT = true;
          const user = auth.user();
          $window.datashop.app.vent.emit('datashop-auth:setMixpanelUser', user);
        }
        let user = auth.user();
        if (!user) {
          user = {};
        }
        $window.datashop.app.vent.emit('datashop-auth:initChatService', user);
      });
      /** SURVEY END */

      /**
       * Mount PlatformManagementNav
       */
      $window.datashop.app.vent.on('platform-management:mountSidenav', () => {
        $window.datashop.app.vent.on('skeleton:appPublicConfigReady', () => {
          const config = $window.datashop.app.module('getPublicConfig')(
            'platform'
          );
          let url = '/api/platformManagementNav?partials[]=sidenav';
          // check for devMode
          const devMode = window.location.search.indexOf('dev') >= 0;
          if (devMode) {
            url += '&dev=true';
          }
          const platformManagementNavUrl = `${config.hostUrl}${url}`;
          return fetch(platformManagementNavUrl)
            .then(response => response.json())
            .then(response => {
              // Handle app load on clicking the anchor
              const platformNav = document.querySelector(
                '#platformManagementNav'
              );
              platformNav.innerHTML = response.sidenav;
              let anchorTags = [].slice.call(
                document.querySelectorAll('#platformManagementNav nav .view')
              );
              anchorTags.forEach(node => {
                node.onclick = e => {
                  // Load app
                  window.handleOnClick(e);
                };
                const dropdown =
                  node.nextElementSibling &&
                  node.nextElementSibling.id === 'dropdown-arrow'
                    ? node.nextElementSibling
                    : null;
                let nestedList =
                  node.parentElement && node.parentElement.nextElementSibling
                    ? node.parentElement.nextElementSibling
                    : null;
                if (
                  dropdown &&
                  nestedList &&
                  nestedList.parentElement &&
                  nestedList.parentElement.className.indexOf('collapse') !== -1
                ) {
                  dropdown.onclick = e => {
                    e.stopImmediatePropagation();
                    e.preventDefault();
                    // Handle menu expansion on clicking anchor element
                    if (nestedList.style.display === 'block') {
                      nestedList.style.display = 'none';
                      dropdown.innerHTML = 'keyboard_arrow_down';
                    } else {
                      nestedList.style.display = 'block';
                      dropdown.innerHTML = 'keyboard_arrow_up';
                    }
                  };
                }
              });
              return response;
            })
            .then(response => {
              // Active link
              let navLink = $document.querySelector(
                `#platformManagementNav nav a[href="${window.location.pathname}${window.location.search}"]`
              );
              let currentActiveLink = $document.querySelector(
                `#platformManagementNav nav a.active`
              );
              if (currentActiveLink)
                currentActiveLink.classList.remove('active');
              if (navLink) navLink.classList.add('active');
              return response;
            })
            .catch(error => {
              console.log('Error in loading platformManagementSidenav', error);
            });
        });
      });

      /**
       * Unmount PlatformManagementNav
       */
      $window.datashop.app.vent.on('platform-management:unmountSidenav', () => {
        const platformNav = document.querySelector('#platformManagementNav');
        if (platformNav) {
          platformNav.innerHTML = '';
        }
      });

      $window.datashop.app.vent.on('app-view:loading', name => {
        // set custom view to kfuseRUM
        if (
          kfuseRUM.tracking === 'enabled' &&
          name &&
          name.length > 0 &&
          kfuseRumSDK.startView
        ) {
          kfuseRumSDK.startView({ name: `${name}-app` });
        }
      });

      /**
       * Mount and unmount PlatformManagementNav
       * Set current link as active in the sidenav
       */
      $window.datashop.app.vent.on(
        'datashop-app:routeChangeStart',
        ({ toPath, toParams, time }) => {
          if (toPath.pathname.indexOf('platform-settings/') === -1) {
            $window.datashop.app.vent.emit(
              'platform-management:unmountSidenav'
            );
            return;
          }

          // Active link
          let navLink = $document.querySelector(
            `#platformManagementNav nav a[href="${toPath.pathname}"]`
          );
          let currentActiveLink = $document.querySelector(
            `#platformManagementNav nav a.active`
          );
          if (currentActiveLink) currentActiveLink.classList.remove('active');
          if (navLink) {
            navLink.classList.add('active');
          } else {
            // Re-render sidenav only if no matching pathname anchor
            $window.datashop.app.vent.emit('platform-management:mountSidenav');
          }
        }
      );

      /**
       * P360 - Reset side nav state on login
       */
      $window.datashop.app.vent.on('datashop-auth:loginSuccess', _ => {
        try {
          localStorage.setItem('datashop-patient.isSidebarCollapsed', false);
        } catch (err) {
          console.warn('Unable to reset P360 sidenav state.');
          return false;
        }
      });

      /**
       * P360 - Reset DP360 sidebar state on login
       */
      $window.datashop.app.vent.on('datashop-auth:loginSuccess', _ => {
        try {
          localStorage.setItem(
            'datashop-patientSidebar.isDP360Collapsed',
            true
          );
        } catch (err) {
          console.warn('Unable to reset DP360 sidebar state.');
          return false;
        }
      });

      /**
       * P360 - Reset DP360 sidebar appsClickCount on login
       */
      $window.datashop.app.vent.on('datashop-auth:loginSuccess', _ => {
        try {
          localStorage.setItem('datashop-patientSidebar.appsClickCount', 0);
        } catch (err) {
          console.warn('Unable to reset DP360 sidebar appsClickCount.');
          return false;
        }
      });

      /**
       * Init chat Component
       */
      $window.datashop.app.vent.on('datashop-auth:initChatService', user => {
        const userDetails = () => ({
          token: user.token,
          name: user.name,
          email: user.email,
          userId: user.id
        });

        const configurationDetails = () => ({
          tenant: $window.skeletonPwa.container.appCfg.config.getStreamTenant,
          chatServiceURL:
            $window.skeletonPwa.container.appCfg.config.chatServiceAddress,
          hostURL: $window.skeletonPwa.container.appCfg.host
        });

        $window.ChatConfiguration = {
          configurationDetails,
          userDetails
        };
      });

      /**
       * Chat Component END
       */

      /**
       * Expiry - Show notification expiry modal for only x times, default - 5
       */
      $window.datashop.app.vent.on('datashop-auth:loginSuccess', _ => {
        try {
          const sessionTimeoutMeta = localStorage.getItem('sessionTimeoutMeta');
          if (!sessionTimeoutMeta) {
            const timeObj = JSON.stringify({
              shownTimes: 0,
              lastUpdated: ''
            });
            localStorage.setItem('sessionTimeoutMeta', timeObj);
          }
        } catch (err) {
          console.warn('Unable to set expiry count.');
          return false;
        }
      });

      /**
       * Send user notification x mins before timeout
       * idleTime: 2, default - 2 In mins, the time before expiry to notify the user
       */
      $window.datashop.app.vent.on('datashop-auth:loginSuccess', _ => {
        try {
          const {
            sessionTime,
            idleTime = 2,
            images
          } = skeletonPwa.container.auth.appConfig.config;
          const iconLogo = images.brand_icon.file_url;
          const timeoutTime = sessionTime - idleTime;
          const idleConfig = {
            debug: true,
            keepTracking: true,
            idleTime: timeoutTime,
            onIdle: () => {
              const permission = Notification.requestPermission();
              permission.then(res => {
                if (res === 'granted') {
                  const expireNotification = new Notification(
                    'Session will expire soon',
                    {
                      body:
                        'Your session will expire after 2 minutes. Click here to resume session',
                      vibrate: true,
                      icon: iconLogo
                    }
                  );
                  expireNotification.onclick = () => window.focus();
                }
              });
            }
          };
          const notification = new IdleJs(idleConfig);
          notification.start();
        } catch (err) {
          console.warn('Unable to send notification');
          return false;
        }
      });
    };

    skeletonEngine
      .bootstrap('datashop', appCfg)
      .then(loadApp)
      .catch(err => {
        console.log(err);
      });
    if (module.hot) {
      module.hot.accept(e => {
        skeletonPwa.resetProviders();
        console.log('hotPatch');
        console.log(e);
      });
    }
  });
